import React from "react";

type ProfileImageProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  borderOutlineColor?: string;
};

const MonkeyProfileSolo = ({ color, width, height, style, borderOutlineColor }: ProfileImageProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-2 -2 184 184"
    fill="none"
    style={style}
  >
    <g clipPath="url(#clip0_446_330)">
      <path
        d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
        fill="var(--jungle-art-avatar-disc, #FBFFDF)"
        stroke={borderOutlineColor}
        strokeWidth={borderOutlineColor ? 1 : 0}
      />
      <mask
        id="mask0_446_330"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="180"
        height="180"
      >
        <path
          d="M90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_446_330)">
        <path
          d="M162.85 187.42C163.33 187.73 163.79 186.94 163.82 186.36C164.13 180.48 161.35 174.89 158.39 169.8C153.42 161.26 147.79 153.13 141.6 145.42C140.09 143.54 138.52 141.68 136.58 140.26C135.18 139.23 130.22 131.67 128.51 131.59C126.8 131.51 128.18 138.32 127.54 140.24C127.04 141.74 126.65 143.27 126.85 144.84C128.25 156.11 126.95 167.91 129.97 178.86C130.26 179.86 130.54 180.89 131.14 181.74C132.42 183.57 134.73 184.28 136.9 184.88C142.01 186.31 147.11 187.7 152.19 189.13C154.3 189.73 156.44 190.3 158.64 190.24C160.84 190.18 161.52 189.18 162.86 187.44V187.41L162.85 187.42Z"
          fill="#894C0A"
        />
        <path
          d="M157.48 169.91C159.78 169.91 161.86 171.05 163.34 172.82C163.96 173.56 165.06 174.16 165.44 175.16C165.67 175.76 165.55 176.53 165.04 176.9C164.47 177.3 163.67 177.1 162.99 177.16C161.88 175.88 160.31 175.05 159.03 173.94C158.52 173.48 158.03 172.97 157.75 172.34C157.55 171.86 157.46 171.34 157.41 170.83C157.35 170.49 157.5 170.26 157.47 169.92H157.5L157.48 169.91Z"
          fill="#894C0A"
        />
        <path
          d="M164.98 186.37C165.12 183.66 164.58 181.01 163.7 178.47C164.21 178.47 164.7 178.56 165.13 178.21C165.64 177.81 165.76 177.07 165.53 176.47C165.3 175.87 164.82 175.41 164.33 174.99C163.36 174.19 162.33 173.48 161.25 172.85C160.85 172.08 160.19 170.94 159.77 170.17C157.69 170.48 155.78 170.94 153.89 172.05C152.81 172.71 151.81 173.5 150.95 174.42C148.15 177.39 146.93 181.89 146.99 185.97C146.99 186.43 147.05 186.91 147.1 187.37C149.18 187.94 151.26 188.54 153.35 189.14C155.46 189.74 157.63 190.31 159.8 190.25C161.97 190.19 162.65 189.19 163.99 187.45C164.47 187.76 164.96 186.97 164.99 186.37H164.98Z"
          fill="#FFD39F"
        />
        <path
          d="M121.91 114.6C128.16 122.33 134.92 138.79 135.32 148.69C136.2 169.88 133.78 185.8 141.02 205.74C143.19 211.7 143.3 217.83 143.87 224.17C144.81 234.67 145.5 246.19 139.31 254.75C135.92 259.46 130.75 262.65 125.25 264.53C119.74 266.41 113.93 267.01 108.14 267.27C90.85 268.07 73.43 266.01 56.8 261.14C47.42 258.4 38.26 255.04 32.04 247.48C27.93 242.49 26.48 235.73 26.48 229.25C26.48 222.77 27.85 216.39 28.7 209.94C31.18 191.48 29.7 172.46 34.72 154.55C36.94 146.56 40.42 139 43.88 131.47C44.28 130.61 44.74 129.67 45.62 129.3C51.04 121.28 59.4 116.52 68.67 113.73C77.94 110.93 87.7 110.48 97.37 110.56C102.56 110.62 107.84 110.82 112.77 112.41C115.99 113.44 118.59 113.92 121.9 114.58L121.93 114.61L121.91 114.6Z"
          fill="#9B5808"
        />
        <path
          d="M84.48 231.84C84.31 234.49 86.25 236.92 88.62 238.09C90.99 239.26 93.73 239.4 96.38 239.4C102.17 239.34 107.96 238.57 113.58 237.12C117.49 236.09 121.65 234.72 125.67 235.15C129.09 234.12 130.83 230.39 132.03 227.02C134.2 220.94 135.99 214.7 136.51 208.28C137.03 201.86 135.57 195.53 132.94 189.65C127.24 176.81 133.51 161.35 128.92 148.06C128.06 145.61 126.87 143.27 125.07 141.41C121.56 137.73 116.14 136.3 111.06 136.73C105.98 137.16 101.19 139.24 96.74 141.69C94.89 142.72 93.09 143.8 91.46 145.11C86.9 148.85 83.99 154.29 82.33 159.97C80.68 165.65 80.19 171.58 79.71 177.46C78.45 192.78 78.2 208.38 80.85 223.53C81.39 226.55 82.28 229.72 84.47 231.83L84.48 231.84Z"
          fill="#BE8960"
        />
        <path
          d="M130.52 58.6399C131.49 50.2799 145.18 46.9199 152.34 46.7999C171.42 46.4899 173.59 70.0999 167.63 83.1699C164.06 91.7299 150.4 98.9699 143.61 89.6699C135.97 80.7999 128.12 70.9899 130.52 58.6399Z"
          fill="#894C0A"
        />
        <path
          d="M134.29 61.23C135 55.18 144.87 52.76 150.06 52.67C163.84 52.44 165.43 69.53 161.13 78.97C158.53 85.16 148.69 90.38 143.76 83.68C138.23 77.26 132.55 70.19 134.29 61.23Z"
          fill="#BE8960"
        />
        <path
          d="M98.8 44.15C72.96 38.76 43.03 46.26 32.88 73.13C18.99 108.79 35.16 137.74 75.75 134.12C97.6 131.61 130.8 127.56 143.9 109.3C151.86 97.63 150.86 81.32 144.44 69.19C135.48 52.82 117.14 47.11 99.34 44.23L98.8 44.14V44.15Z"
          fill="#9B5808"
        />
        <path
          d="M61.3499 67.23C54.4499 58.16 40.5599 52.83 29.3499 54.88C18.1399 56.93 10.2699 61.7 7.01993 72.62C5.73993 76.9 6.90993 84.86 8.18993 89.11C10.0699 95.47 15.3799 100.41 21.4299 103.17C27.4799 105.93 30.8399 107.31 37.4899 107.51C43.4799 107.68 54.4099 107.4 59.5099 104.23C61.6799 100.35 60.9399 97.21 60.6499 92.79C60.4499 89.94 60.2499 83.52 60.3599 80.67C60.5899 74.57 62.0699 73.31 61.4199 67.23H61.3599H61.3499Z"
          fill="#9B5808"
        />
        <path
          d="M58.13 72.27C47.32 54.64 13.83 61.63 19.88 84.56C22.62 97.74 39.7 100.36 51.88 96.94C61.86 93.6 55.84 86.27 58.7 73.44L58.13 72.27Z"
          fill="#BE8960"
        />
        <path
          d="M130.32 115.72C135.68 113.52 141.22 108.28 143.24 103.17C146.81 94.2701 146.38 84.1701 143.38 75.0401C141.47 69.1901 138.99 62.8301 133.25 59.7801C131.22 58.7001 128.91 58.0701 126.66 58.4101C124.41 58.7501 122.24 60.1501 121.38 62.2901C120.98 63.2901 120.87 64.4301 120.12 65.2301C119.37 66.0301 118.67 66.0601 117.55 64.9401C112.36 59.5801 105.51 55.6701 98.04 55.5001C92.25 55.3901 86.57 57.5801 81.7 60.6901C77.71 63.2001 74.4 65.5401 71.06 70.7001C66.66 77.5301 65.49 86.0201 67.4 93.9301C68.95 100.37 75.31 108.23 81.09 111.47C87.24 114.92 93.79 117.89 100.79 118.87C104.13 119.33 107.49 119.44 110.83 119.47C113.34 119.5 115.88 119.53 118.39 119.21C122.5 118.7 126.46 117.27 130.28 115.7H130.31L130.32 115.72Z"
          fill="#FFD29F"
        />
        <path
          d="M89.2999 68.5599C87.5899 68.4499 85.8799 68.6699 84.2499 69.5899C83.4199 70.0499 82.5999 70.6999 82.0499 71.9599C81.6499 72.8999 81.4199 74.1599 81.4799 75.3499C81.5399 76.5399 81.7899 77.7699 82.2499 78.5999C83.0199 80.0299 84.1599 80.3699 85.2199 80.1699C86.4999 79.9099 87.7299 78.8899 88.6999 77.2899C89.0999 76.6299 89.4399 75.8899 89.6999 74.9799C89.8999 74.1499 90.0099 73.2399 90.0999 72.3299C90.1599 71.8199 90.1899 71.3299 90.1599 70.8199C90.0999 70.0499 89.8699 69.3399 89.5299 68.9099C89.1899 68.4799 88.7599 68.3699 88.3599 68.5999"
          fill="#5C2600"
        />
        <path
          d="M88.6899 68.7298C81.3599 72.9798 84.2099 83.3098 92.1399 84.8998C100.07 86.4998 107.71 77.7698 103.69 71.7198C100.12 66.2098 93.8499 66.4398 88.6899 68.6998V68.7298Z"
          fill="#FAF6D6"
        />
        <path
          d="M92.0699 69.4198C87.1399 72.7298 88.7899 81.8898 94.5799 83.2498C100.37 84.6198 105.93 77.1498 102.99 71.9498C100.39 67.2398 93.8299 65.8998 92.0699 69.4098V69.4198Z"
          fill="#522E2D"
        />
        <path
          d="M137.03 63.0599C137.89 62.9499 138.77 63.1699 139.63 63.9399C140.06 64.3399 140.46 64.8799 140.74 65.9899C140.94 66.8199 141.05 67.8699 141.03 68.9299C141.01 69.9899 140.86 71.0099 140.63 71.7499C140.23 72.9799 139.66 73.2899 139.12 73.1199C138.46 72.8899 137.84 72.0099 137.35 70.6099C137.15 70.0399 136.95 69.3799 136.84 68.6099C136.73 67.8999 136.67 67.0999 136.64 66.2999C136.64 65.8699 136.61 65.4199 136.64 64.9899C136.64 64.3099 136.78 63.7099 136.95 63.3399C137.12 62.9699 137.35 62.8799 137.55 63.0799"
          fill="#5C2600"
        />
        <path
          d="M137.18 63.2298C140.92 66.9098 139.46 75.8398 135.41 77.2398C131.36 78.6398 127.45 71.0498 129.51 65.8598C131.34 61.0998 134.53 61.2998 137.18 63.2598V63.2298Z"
          fill="#FAF6D6"
        />
        <path
          d="M137.18 63.8798C139.98 67.0698 139.03 75.9198 135.75 77.2298C132.47 78.5398 129.27 71.3298 130.96 66.3598C132.44 61.8198 136.18 60.5398 137.18 63.9098V63.8798Z"
          fill="#522E2D"
        />
        <path
          opacity="0.1"
          d="M70.1899 104.31C74.1499 100.72 79.7199 99.3999 85.0499 99.2599C88.3599 99.1699 91.7799 99.4899 94.6599 101.11C97.4799 102.71 99.5099 105.42 100.96 108.3C103.1 112.55 104.1 117.74 101.96 121.99C100.11 125.64 96.4799 129.01 92.5499 130.12C87.2199 131.6 83.9899 131.43 80.0599 130.26C75.6399 128.95 69.4799 126.35 67.1099 122.07C64.3999 117.19 66.2499 107.86 70.2199 104.3H70.1899V104.31Z"
          fill="#FF5580"
        />
        <path
          opacity="0.1"
          d="M144.36 110.01C147.01 105.9 148.58 101.28 149.24 96.4599C148.87 94.3199 148.21 92.3499 147.39 91.2099C145.39 88.4699 142.57 87.4399 139.86 87.3299C138.18 87.2399 136.44 87.4999 134.98 88.7599C133.55 89.9899 132.53 92.0699 131.79 94.2699C130.71 97.5199 130.19 101.52 131.28 104.74C132.22 107.54 134.08 110.1 136.07 110.96C138.78 112.1 140.41 111.96 142.4 111.07C143.03 110.78 143.71 110.44 144.4 110.01H144.37H144.36Z"
          fill="#FF5580"
        />
        <path
          d="M123.13 78.8599C129.58 74.3199 127.41 68.9899 121.13 70.1899C114.6 71.3299 114.71 77.2899 122.61 78.9799L123.12 78.8699L123.13 78.8599Z"
          fill="#522E2D"
        />
        <path
          d="M72.6499 43.2899C72.6499 43.2899 80.1499 31.9399 86.5699 31.9399C85.9399 35.1299 85.9399 37.6199 85.9399 37.6199L90.3299 36.7399C90.3299 36.7399 82.7399 41.5599 101.94 44.7599C85.9399 47.9499 72.6699 43.3299 72.6699 43.3299L72.6399 43.2999L72.6499 43.2899Z"
          fill="#9B5808"
        />
        <path
          d="M117.4 97.4899C119.51 98.7999 120.99 99.5399 123.48 99.3999C125.59 99.2899 126.96 98.9199 128.44 97.4299"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M122.79 78.6299L124.02 91.7199C124.28 94.4299 124.13 95.5699 123.51 99.3899"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M84.3399 153.91C80.9999 158.59 80.9999 165.41 84.3399 170.08C85.7899 172.11 87.7599 173.73 89.8199 175.19C92.3599 177.02 95.0399 178.64 97.7199 180.3C105.19 184.86 112.64 189.46 120.11 194.02C123.5 196.1 127.16 198.5 128.47 202.26C128.9 203.52 129.04 204.86 128.95 206.2C128.78 208.4 127.84 210.71 125.9 211.76C124.73 212.42 123.33 212.53 121.99 212.47C119.82 212.38 117.68 211.84 115.57 211.3C106.56 209.02 97.5099 206.76 88.5899 204.17C77.2899 200.89 65.4299 196.61 58.4699 187.17C55.2799 182.83 53.3399 177.7 51.4499 172.62C49.9699 168.63 51.9599 164.01 52.9299 159.84C53.3599 158.01 53.7899 156.19 54.5599 154.51C56.7299 149.72 61.3499 146.44 66.1999 144.33C68.3699 143.39 70.6799 142.59 73.0499 142.48C75.4199 142.37 77.8999 142.96 79.6999 144.53C82.4999 146.93 83.9199 150.29 84.3799 153.94L84.3499 153.91H84.3399Z"
          fill="#9B5808"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_446_330">
        <rect width="180" height="180" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MonkeyProfileSolo;
